module.exports = __webpack_public_path__ + "assets/img/fun_slow.cc634e3f.svg";